import { cacheDom } from '../utils/QuerySelectors.js'
import { getCart } from '../utils/Cart.js'

const dom = {}
const qs = {
  freeshippingBar: 'data-freeshipping-announcementbar',
  freeshippingBarText: 'data-freeshipping-announcementbar-text',
  settings: 'data-settings',
}
const qsAll = {}
const state = {
  data: {},
  threshold: 0,
  cart: null,
}

const thresholdMet = () => {
  return state.threshold == 0 || state.threshold < parseFloat(state.cart.total_price / 100.0)
}

const cleanThresholdMessage = () => {
  const toGo = (state.threshold - (parseFloat(state.cart.total_price / 100.0) || 0))
    .toLocaleString(undefined, { minimumFractionDigits: 2 })
    .replace('.00', '')
  return state.cart.item_count == 0
    ? `Free Shipping on All Orders Above $${state.threshold}. <a class="underline" href="${state.data.continueShoppingUrl}">Show Now</a>`
    : `${state.data.thresholdMessage.replace('$TOTAL', toGo)} <a class="underline" href="${
        state.data.continueShoppingUrl
      }">Continue shopping.</a>`
}
window.updateFreeShippingBar = (cartData) => {
  if (dom.freeshippingBar) {
    state.cart = cartData.cart ? cartData.cart : cartData
    state.data = JSON.parse(dom.freeshippingBar.querySelector(`[${qs.settings}]`).innerHTML)
    state.threshold = parseFloat(state.data.threshold) / 100.0

    if (thresholdMet())
      dom.freeshippingBarText.innerHTML = `${state.data.thresholdReachedMessage}<br><small class="font-bold">${state.data.shippingCountriesMessage}</small>`
    else dom.freeshippingBarText.innerHTML = cleanThresholdMessage()
  }
}

export const setupAnnouncementBar = () => {
  cacheDom(dom, qs, qsAll)
  getCart((cartData) => {
    window.updateFreeShippingBar(cartData)
  }, false)
}
